export default "__VITE_ASSET__fbc698de__"